import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExcelService {

  constructor() { }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    
    //json.replaceAll(search, replaceWith);
    json.forEach(function(item) {
      if (item.isActive === true) {
        item.isActive = 'Active'
      }
      if (item.isActive === false) {
        item.isActive = 'Inactive'
      }
      if (item.role === 'invoice_admin') {
        item.role = 'Invoice Admin'
      }
      if (item.role === 'invoice_viewer') {
        item.role = 'Invoice Viewer'
      }
      if (item.role === 'idadm') {
        item.role = 'IDADM'
      }
      if (item.role === 'admin') {
        item.role = 'Admin'
      }

      
    });

    json = JSON.parse(JSON.stringify(json).split('"isActive":').join('"Status":'));
   
    const myworksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const myworkbook: XLSX.WorkBook = { Sheets: { 'data': myworksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(myworkbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
  }

}